
<template>
  <div>
    <NavigationBar/>
    <router-view />
    <Footer/>
  </div>
</template>

<style>
  @import "./css/style.css";
</style>

<script>

import NavigationBar from './components/NavigationBar.vue'
import Footer from './components/Footer'

export default {
  name: 'app',
  components: {
    NavigationBar,
    Footer
  }
}
</script>